module.exports = __webpack_public_path__ + "img/prohealth.c50d0cb3.png";